import proj1 from "../../assets/images/portfolio/p1.jpg";
import proj2 from "../../assets/images/portfolio/p2.jpg";
import proj3 from "../../assets/images/portfolio/p3.jpg";
import proj4 from "../../assets/images/portfolio/p4.jpg";
import proj5 from "../../assets/images/portfolio/p5.jpg";
import proj6 from "../../assets/images/portfolio/p6.jpg";
import proj7 from "../../assets/images/portfolio/p7.jpg";
import proj8 from "../../assets/images/portfolio/p8.jpg";
import proj9 from "../../assets/images/portfolio/p9.jpg";
import proj10 from "../../assets/images/portfolio/p10.jpg";
import proj11 from "../../assets/images/portfolio/p11.jpg";
import proj12 from "../../assets/images/portfolio/p12.jpg";
import proj13 from "../../assets/images/portfolio/p13.jpg";
import proj14 from "../../assets/images/portfolio/p14.jpg";
import proj15 from "../../assets/images/portfolio/P15.png";
import proj16 from "../../assets/images/portfolio/P16.png";
import proj17 from "../../assets/images/portfolio/P17.jpg";
import proj18 from "../../assets/images/portfolio/P18.jpg";


const ProjectsPreviewData = [
  {
    id: "billboard",
    img: proj1,
    name: "BILLBOARD",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Billboard",
  },
  {
    id: "flyer-backside",
    img: proj2,
    name: "flyer-backside",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Flyer backside",
  },
  {
    id: "magazine",
    img: proj3,
    name: "magazine",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Magazine",
  },
  {
    id: "news ad",
    img: proj4,
    name: "news ad",
    stack: [],
    src: "#",
    source: "#",
    description:
      "News ad",
  },
  {
    id: "pole banner",
    img: proj5,
    name: "pole banner",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Pole banner",
  },
  {
    id: "poster",
    img: proj6,
    name: "poster",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Poster",
  },
  {
    id: "callender",
    img: proj7,
    name: "callender",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Callender",
  },
  {
    id: "Flyer",
    img: proj8,
    name: "Flyer",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Flyer",
  },
  {
    id: "Keychain",
    img: proj9,
    name: "Keychain",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Keychain",
  },
  {
    id: "Standee",
    img: proj10,
    name: "Standee",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Standee",
  },
  {
    id: "Visiting card",
    img: proj11,
    name: "Visiting card",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Visiting card",
  },
  {
    id: "Visiting card backside",
    img: proj12,
    name: "Visiting card backside",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Visiting card backside",
  },
  {
    id: "Letter head",
    img: proj13,
    name: "Letter head",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Letter head",
  },
  {
    id: "Envelope",
    img: proj14,
    name: "Envelope",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Envelope",
  },
  {
    id: "Logo",
    img: proj15,
    name: "Logo",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Logo",
  },
  {
    id: "Illustration",
    img: proj16,
    name: "Illustration",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Illustration",
  },
  {
    id: "Social media post",
    img: proj17,
    name: "Social media post",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Social media post",
  },
  {
    id: "Web page",
    img: proj18,
    name: "Web page",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Web page",
  },
];

const ProjectsData = [
  {
    id: "billboard",
    img: proj1,
    name: "BILLBOARD",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Billboard",
  },
  {
    id: "flyer-backside",
    img: proj2,
    name: "flyer-backside",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Flyer backside",
  },
  {
    id: "magazine",
    img: proj3,
    name: "magazine",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Magazine",
  },
  {
    id: "news ad",
    img: proj4,
    name: "news ad",
    stack: [],
    src: "#",
    source: "#",
    description:
      "News ad",
  },
  {
    id: "pole banner",
    img: proj5,
    name: "pole banner",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Pole banner",
  },
  {
    id: "poster",
    img: proj6,
    name: "poster",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Poster",
  },
  {
    id: "callender",
    img: proj7,
    name: "callender",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Callender",
  },
  {
    id: "Flyer",
    img: proj8,
    name: "Flyer",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Flyer",
  },
  {
    id: "Keychain",
    img: proj9,
    name: "Keychain",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Keychain",
  },
  {
    id: "Standee",
    img: proj10,
    name: "Standee",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Standee",
  },
  {
    id: "Visiting card",
    img: proj11,
    name: "Visiting card",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Visiting card",
  },
  {
    id: "Visiting card backside",
    img: proj12,
    name: "Visiting card backside",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Visiting card backside",
  },
  {
    id: "Letter head",
    img: proj13,
    name: "Letter head",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Letter head",
  },
  {
    id: "Envelope",
    img: proj14,
    name: "Envelope",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Envelope",
  },
  {
    id: "Logo",
    img: proj15,
    name: "Logo",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Logo",
  },
  {
    id: "Illustration",
    img: proj16,
    name: "Illustration",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Illustration",
  },
  {
    id: "Social media post",
    img: proj17,
    name: "Social media post",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Social media post",
  },
  {
    id: "Web page",
    img: proj18,
    name: "Web page",
    stack: [],
    src: "#",
    source: "#",
    description:
      "Web page",
  },
  
];

export { ProjectsData, ProjectsPreviewData };
